import type { ApolloError } from '@apollo/client';
import { isHandledQuoteTaxError } from './isHandledQuoteTaxError';
import { isInvalidZipCodeError } from './isInvalidZipCodeError';

export function isNonFatalQuoteError(error: ApolloError | undefined) {
  if (!error || !error.graphQLErrors || !error.graphQLErrors.length) {
    return false;
  }

  return isHandledQuoteTaxError(error) || isInvalidZipCodeError(error);
}
